module.exports = __webpack_public_path__ + "mainassets/img/bg-cookie-narrow.77b3bb97.jpg";